import { render, staticRenderFns } from "./templateNotice.vue?vue&type=template&id=62b97d66&"
import script from "./templateNotice.vue?vue&type=script&lang=js&"
export * from "./templateNotice.vue?vue&type=script&lang=js&"
import style0 from "./templateNotice.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports